import type { WorkspaceAppManifest } from './workspaceManifest';

export const APP_MANIFEST = {
    appId: 'document-management',
    permissionsPrefix: 'dms',
    displayName: 'Document Management',

    navSections: [
        { key: 'documents', label: 'Documents', route: '/documents/dmsDocuments' },
        { key: 'configuration', label: 'Configuration', route: '/documents/dmsDocumentCategories' },
        { key: 'audit', label: 'Audit & Tools', route: '/documents/dmsDocumentAccessLogs' },
    ],

    resources: [
        { key: 'documentInfo', label: 'All Documents', navSection: 'documents' },
        { key: 'documentCategory', label: 'Document Categories', navSection: 'configuration' },
        { key: 'documentType', label: 'Document Types', navSection: 'configuration' },
        { key: 'accessLog', label: 'Access Log', navSection: 'audit' },
        { key: 'legacyMigration', label: 'Legacy Migration', navSection: 'audit' },
    ],
} satisfies WorkspaceAppManifest;
